module.exports = __webpack_public_path__ + "static/media/lotus-works.1f4fe3d4.jpg";